const smtBadgeComponent = {
  subtle: {
    green: {
      color: {
        default: 'green.800',
        _dark: 'green.600'
      },
      bgColor: {
        default: 'green.300',
        _dark: 'green.900'
      }
    },
    yellow: {
      color: {
        default: 'yellow.800',
        _dark: 'yellow.300'
      },
      bgColor: {
        default: 'yellow.300',
        _dark: 'yellow.900'
      }
    }
  }
};

export default smtBadgeComponent;
